<template>
<div>
  <div class="product-choice" v-if="product.type == $const.PRODUCT_TYPES.STOCK">
    <div class="specific" v-for="attr in product.stockAttributes" :class="`-${attr.key}`">
      <div class="label">Choose your {{ attr.key }}: <span class="selected">{{ choices[attr.key] || '-' }}</span></div>
      <ul class="choice">
        <li class="item" v-for="choice in attr.attributes">
          <button class="option" :class="choiceClasses(attr.key, choice)" @click="choose(attr.key, choice)">{{ choice }}</button>
          &nbsp;
        </li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ProductChoice',
  props: {
    product: {
      type: Object,
      required: true
    },
    initialChoices: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      choices: this.initialChoices
    }
  },
  methods: {
    choose (key, choice) {
      if (this.choices[key] === choice) {
        return
      }
      this.$set(this.choices, key, choice)
      this.$forceUpdate()
      this.$emit('attrChanged', this.choices)
    },
    choiceClasses (key, choice) {
      return {
        [`-${choice}`]: true,
        active: this.choices[key] === choice
      }
    },
    getSelectedChoices () {
      return this.choices
    }
  }
}
</script>

<style scoped lang="scss">

.product-choice {
  font-size: 0.9em;
  text-align: left;

  .selected {
    color: #000;
    text-transform: uppercase;
  }


  .specific {

    .choice {
      list-style: none;
      padding: 0;
      margin: 5px 0;

      .item { display: inline-block; }

        .option {
          display: inline-block;
          color: #000;
          padding: 0 5px;
          display: inline-block;
          background: #fff;
          border: 1px solid #C993C1;
          border-radius: 5px;
          width: 35px;
          font-size: 0.8em;
          line-height: 2em;
          text-align: center;
          text-transform: uppercase;
          cursor: pointer;

          &.active,
          &:hover {
            color: #fff;
            background: #C993C1;
            display: inline-block;
            text-decoration: none;
          }
          &.disable {
            opacity: 0.5;
            color: #999;
            background: #fff;
            border: 1px solid #ccc;
            cursor: not-allowed;
          }
        }
      }

      // ** Choose color
      &.-color {
        .choice {
          .option {
            background: #ccc;
            text-indent: -999em;
            width: 30px;

            &.-white { background: #fff; }
            &.-black { background: #000; }
            &.-blue { background: blue; }

            &.active {
              border: 2px solid #c993c1;
            }
          }
        }
      }

    }


}
</style>



// WEBPACK FOOTER //
// ProductChoice.vue?70a6add4